module.exports = __webpack_public_path__ + "img/qrCode.652ed942.jpg";